export const types = {
  CREATE_DEPLOYMENT_REQUEST: 'ONPREM/CREATE_DEPLOYMENT_REQUEST',
  CREATE_DEPLOYMENT_SUCCESS: 'ONPREM/CREATE_DEPLOYMENT_SUCCESS',
  CREATE_DEPLOYMENT_FAILURE: 'ONPREM/CREATE_DEPLOYMENT_FAILURE',
  DELETE_DEPLOYMENT_REQUEST: 'ONPREM/DELETE_DEPLOYMENT_REQUEST',
  DELETE_DEPLOYMENT_SUCCESS: 'ONPREM/DELETE_DEPLOYMENT_SUCCESS',
  DELETE_DEPLOYMENT_FAILURE: 'ONPREM/DELETE_DEPLOYMENT_FAILURE',
  TEST_CONNECTION_REQUEST: 'ONPREM/TEST_CONNECTION_REQUEST',
  TEST_CONNECTION_SUCCESS: 'ONPREM/TEST_CONNECTION_SUCCESS',
  TEST_CONNECTION_FAILURE: 'ONPREM/TEST_CONNECTION_FAILURE',
  MANUAL_UPGRADE_REQUEST: 'ONPREM/MANUAL_UPGRADE_REQUEST',
  MANUAL_UPGRADE_SUCCESS: 'ONPREM/MANUAL_UPGRADE_SUCCESS',
  MANUAL_UPGRADE_FAILURE: 'ONPREM/MANUAL_UPGRADE_FAILURE',
  SET_AUTO_UPGRADE_REQUEST: 'ONPREM/SET_AUTO_UPGRADE_REQUEST',
  SET_AUTO_UPGRADE_SUCCESS: 'ONPREM/SET_AUTO_UPGRADE_SUCCESS',
  SET_AUTO_UPGRADE_FAILURE: 'ONPREM/SET_AUTO_UPGRADE_FAILURE',
};

export const initialState = {
  error: null,
  errorCode: null,
  isUpdating: false,
  connectionVerified: false,
  token: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.CREATE_DEPLOYMENT_REQUEST:
    case types.DELETE_DEPLOYMENT_REQUEST:
    case types.MANUAL_UPGRADE_REQUEST:
    case types.SET_AUTO_UPGRADE_REQUEST:
      return { ...state, isUpdating: true, error: null, errorCode: null };
    case types.TEST_CONNECTION_REQUEST:
      return {
        ...state,
        isUpdating: true,
        connectionVerified: false,
        error: null,
        errorCode: null,
      };
    case types.CREATE_DEPLOYMENT_SUCCESS:
      return {
        ...state,
        isUpdating: false,
        token: action.token,
        secret: action.secret,
      };
    case types.DELETE_DEPLOYMENT_SUCCESS:
    case types.MANUAL_UPGRADE_SUCCESS:
    case types.SET_AUTO_UPGRADE_SUCCESS:
      return { ...state, isUpdating: false };
    case types.TEST_CONNECTION_SUCCESS:
      return { ...state, isUpdating: false, connectionVerified: true };
    case types.CREATE_DEPLOYMENT_FAILURE:
    case types.DELETE_DEPLOYMENT_FAILURE:
    case types.TEST_CONNECTION_FAILURE:
    case types.MANUAL_UPGRADE_FAILURE:
    case types.SET_AUTO_UPGRADE_FAILURE:
      return {
        ...state,
        isUpdating: false,
        error: action.error,
        errorCode: action.errorCode,
      };
    default:
      return state;
  }
};

export const actions = {
  createDeployment: (organizationUUID) => ({
    type: types.CREATE_DEPLOYMENT_REQUEST,
    organizationUUID,
  }),
  deleteDeployment: (organizationUUID) => ({
    type: types.DELETE_DEPLOYMENT_REQUEST,
    organizationUUID,
  }),
  testConnection: (organizationUUID) => ({
    type: types.TEST_CONNECTION_REQUEST,
    organizationUUID,
  }),
  manualUpgrade: (organizationUUID) => ({
    type: types.MANUAL_UPGRADE_REQUEST,
    organizationUUID,
  }),
  setAutoUpgrade: (organizationUUID, enable) => ({
    type: types.SET_AUTO_UPGRADE_REQUEST,
    organizationUUID,
    enable,
  }),
};
